/**
 * Agent activity limits and frontend-owned copy.
 * Step text always comes from the backend `label` (D-04); only the wrapper copy lives here.
 */

/** Maximum reasoning steps retained per turn (D-16). */
export const MAX_STEPS_PER_TRAIL = 200

// There is intentionally no session-wide trail cap (D-17).

/** Frontend-owned copy (v1 A-05). Step text always comes from the backend `label` (D-04). */
export const AGENT_ACTIVITY_COPY = {
  /** Count beside the shimmering label while the agent works (D-23). */
  stepsOne: '1 step',
  stepsMany: (count: number) => `${count} steps`,
  /** The closed line: the state changed, so the message changes (D-28). */
  reasonedOne: 'Reasoned in 1 step',
  reasonedMany: (count: number) => `Reasoned in ${count} steps`,
  discardedOne: '⋯ 1 earlier step discarded',
  discardedMany: (count: number) => `⋯ ${count} earlier steps discarded`,
} as const
